import {getModelConfig, SyncedBackboneTypes, SyncedGraphQLTypes, SyncedModelName} from './SyncedModels';

/**
 * Function to get the id and typename of a model, which is useful for syncing nested models.
 */
export default function getNestedIdentifier<K extends SyncedModelName>(
  modelName: K,
  model: SyncedBackboneTypes[K]
): Pick<SyncedGraphQLTypes[K], 'id' | '__typename'> {
  const modelConfig = getModelConfig(modelName);
  return {id: modelConfig.getId(model), __typename: modelConfig.__typename};
}
